"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CallbackTypes = _interopRequireWildcard(require("../constants/CallbackTypes"));
var _ServiceRegistry = require("../util/ServiceRegistry");
var _ApiConstants = _interopRequireDefault(require("../constants/ApiConstants"));
var _Events = _interopRequireWildcard(require("../constants/Events"));
var _APICommands = require("../constants/APICommands");
var _ViewMode = _interopRequireWildcard(require("../constants/ViewMode"));
var _dcCore = require("dc-core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

class AdobeDCView {
  constructor(config) {
    this._serviceFactory = new _ServiceRegistry.ServiceRegistry();
    this._initServiceFactory(config);
  }

  // eslint-disable-next-line no-unused-vars
  _initServiceFactory(config) {
    // to be overridden by child class
  }

  /**
   * previewFile(fileInfo, previewConfig) method to preview/embed pdf file.
   * @method
   * @param {object} fileInfo - file information to preview.
   * @param {object} previewConfig - config to control the UI of file preview.
   * @returns {Promise} - promise that resolves to PreviewRef when PDF is rendered.
   */
  previewFile(fileInfo, previewConfig) {
    return this._serviceFactory.getService("ViewSDKInterfaceApp").previewFile(fileInfo, previewConfig || {});
  }

  /**
   * method used to provide progress of file loading (for showing progress in loader)
   *
   * @param {Number} loaded - percentage of file loading
   * @param {Number} total - total file size
   */
  fileLoadingProgress(loaded, total) {
    this._serviceFactory.getService("ViewSDKInterfaceApp").fileProgressLoadingData(loaded, total);
  }

  /**
   * method used to unMount Viewer App
   */
  unMountViewerNode() {
    return this._serviceFactory.getService("ViewSDKInterfaceApp").unMountViewerNode();
  }

  /**
   * method for non dc-client to dynamically change theme
   * @type {string} - {"dark"/"light"/"auto"}
   */
  onThemeChange(theme) {
    _dcCore.providers.theme().then(themeProvider => themeProvider.changeTheme(theme));
  }

  /**
   * Enum for Callback, Events and others
   * @type {enum}
   */
  static get Enum() {
    return {
      CallbackType: _CallbackTypes.default,
      EventType: _CallbackTypes.EditEventTypes,
      ApiResponseCode: _ApiConstants.default.API_RESPONSE,
      Events: _Events.default,
      PDFAnalyticsEvents: _Events.PDFAnalyticsEvents,
      AnnotationEvents: _Events.AnnotationEvents,
      AnnotationTypes: _Events.AnnotationTypes,
      FilePreviewEvents: _Events.FilePreviewEvents,
      OverlayEvents: _Events.OverlayEvents,
      ViewMode: _ViewMode.default,
      EmbedMode: _ViewMode.Preset,
      AnnotationAPICommands: _APICommands.AnnotationAPICommands,
      AppAPICommands: _APICommands.AppAPICommands,
      PreviewAPICommands: _APICommands.PreviewAPICommands
    };
  }

  /**
   * registerCallback method to register callbacks
   * @method
   * @param {string} type - type of callback
   * @param {Function} callback.
   * @param {object} options - parameters for extra information
   */
  registerCallback(type, callback, options) {
    this._serviceFactory.getService("ViewSDKInterfaceApp").registerCallback(type, callback, options || {});
  }

  /**
   * @method
   * @description
   * updateCallbackOptions method to update callback options
   *
   * @param {string} type - type of callback
   * @param {object} options - new callback options
   */
  updateCallbackOptions(type, options) {
    this._serviceFactory.getService("ViewSDKInterfaceApp").updateCallbackOptions(type, options);
  }
}
var _default = exports.default = AdobeDCView;